// extracted by mini-css-extract-plugin
module.exports = {"container":"JobContainer_container__ML_iQ","loadingContainer":"JobContainer_loadingContainer__IZYtc"};